// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles_breadcrumbs__ehv98","title":"styles_title__Y14+L","store":"styles_store__FcpMZ","name":"styles_name__ZplmW","code":"styles_code__YG0Y1"};